import { styled } from "@linaria/react"

import { Card } from "@/components/Card/Card.tsx"

export const TaskViewSceneStyles = {
  ItemCard: styled(Card)`
    cursor: pointer;
    padding: 16px 24px;
    border-radius: var(--border-radius-16);
    transition: background 0.2s ease-in-out;

    &:hover {
      background: var(--text-color-5);
    }
  `,

  SuccessfulItemCard: styled(Card)`
    cursor: pointer;
    padding: 16px 24px;
    border-radius: var(--border-radius-16);
    transition: background 0.2s ease-in-out;

    background: linear-gradient(269deg, #DBFFDE 0.82%, #FAFAFA 26.99%, #FAFAFA 99.18%);

    &:hover {
      background: linear-gradient(269deg, #C5F9CA 0.82%, #F3F3F3 45.15%, #F3F3F3 99.18%), linear-gradient(269deg, #DBFFDE 0.82%, #FAFAFA 26.99%, #FAFAFA 99.18%);
    }
  `,

  MergedItemCard: styled(Card)`
    cursor: pointer;
    padding: 16px 24px;
    border-radius: var(--border-radius-16);
    transition: background 0.2s ease-in-out;

    background: linear-gradient(269deg, #E3E8FF 5.89%, #F4F6FF 15.57%, #FAFAFA 35.24%, #FAFAFA 99.18%);

    &:hover {
      background: linear-gradient(269deg, #E1E6FF 5.89%, #F0F2FE 27.77%, #F3F3F3 49%, #F3F3F3 99.18%);
    }
  `,

  MergedSuccessfulItemCard: styled(Card)`
    cursor: pointer;
    padding: 16px 24px;
    border-radius: var(--border-radius-16);
    transition: background 0.2s ease-in-out;

    background: linear-gradient(269deg, #E3E8FF 6.18%, #F6FFF6 17.04%, #FAFAFA 35.44%, #FAFAFA 99.82%);

    &:hover {
      background: linear-gradient(269deg, #E1E6FF 6.18%, #EDFFED 24.9%, #F3F3F3 50.01%, #F3F3F3 99.82%);
    }
  `,
}
